import { Injectable, signal, TemplateRef, WritableSignal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class PageHeaderService {
  private readonly actionsTemplatesSignal = signal(new Set<TemplateRef<unknown>>());
  private readonly titleTemplateSignal: WritableSignal<TemplateRef<unknown> | null> = signal(null);
  readonly actionsTemplates = this.actionsTemplatesSignal.asReadonly();
  readonly titleTemplate = this.titleTemplateSignal.asReadonly();

  addActionTemplate(templateRef: TemplateRef<unknown>): void {
    this.actionsTemplatesSignal.update((actionsTemplates) => actionsTemplates.add(templateRef));
  }

  removeActionTemplate(templateRef: TemplateRef<unknown>): void {
    this.actionsTemplatesSignal.update((actionsTemplates) => {
      actionsTemplates.delete(templateRef);
      return actionsTemplates;
    });
  }

  resetTitleTemplate(): void {
    this.titleTemplateSignal.set(null);
  }

  setTitleTemplate(templateRef: TemplateRef<unknown>): void {
    this.titleTemplateSignal.set(templateRef);
  }
}
